/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GenericCounterKey = {
    PLACES_API_CALLS: 'PLACES_API_CALLS',
    AUTOCOMPLETE_API_CALLS: 'AUTOCOMPLETE_API_CALLS'
} as const;
export type GenericCounterKey = typeof GenericCounterKey[keyof typeof GenericCounterKey];


export function instanceOfGenericCounterKey(value: any): boolean {
    for (const key in GenericCounterKey) {
        if (Object.prototype.hasOwnProperty.call(GenericCounterKey, key)) {
            if (GenericCounterKey[key as keyof typeof GenericCounterKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenericCounterKeyFromJSON(json: any): GenericCounterKey {
    return GenericCounterKeyFromJSONTyped(json, false);
}

export function GenericCounterKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericCounterKey {
    return json as GenericCounterKey;
}

export function GenericCounterKeyToJSON(value?: GenericCounterKey | null): any {
    return value as any;
}

export function GenericCounterKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): GenericCounterKey {
    return value as GenericCounterKey;
}

